const languageTranslations = {};
languageTranslations.ar = require("./ar.json");
languageTranslations.da = require("./da.json");
languageTranslations.de = require("./de.json");
languageTranslations.en = require("./en.json");
languageTranslations.es = require("./es.json");
languageTranslations.fi = require("./fi.json");
languageTranslations.fr = require("./fr.json");
languageTranslations.ja = require("./ja.json");
languageTranslations.ko = require("./ko.json");
languageTranslations.nb = require("./nb.json");
languageTranslations.nl = require("./nl.json");
languageTranslations.pt = require("./pt.json");
languageTranslations.sv = require("./sv.json");
languageTranslations.zh_CN = require("./zh_CN.json");
languageTranslations.zh_TW = require("./zh_TW.json");
module.exports = languageTranslations;
